<template>
  <!-- id="grad" -->
  <v-toolbar 
    v-if="user !== null && user !== undefined"
    clipped
    fixed
    class="elevation-8"
    color="rgba(250,250,250,1)"
    dense
    style="z-index: 5">
    <!-- Brand for Desktop -->
    <v-toolbar-title
      v-if="!isMobile"
      class="wevent_icon_wrapper_brand">
      <img
        :src="getBrand"
        class="wevent_icon" 
        alt="WeVent">
    </v-toolbar-title>


    <!-- Left Nav Item - Mobile -->
    <v-toolbar-items 
      v-if="isMobile">
      <!-- <v-scroll-x-transition 
        leave-absolute
        hide-on-leave
        mode="out-in"> -->
      <v-btn 
        v-for="item in navItemLeft"
        :key="item.title"
        :disabled="item.disabled"

        icon
        @click.prevent="getSelf()[item.method](item.payload)">
        <v-icon 
          class="wevent_icon_wrapper_icons" 
          color="blue-grey lighten-1">
          {{ item.icon }}
        </v-icon>
      </v-btn>
      <!-- </v-scroll-x-transition> -->
    </v-toolbar-items>
   

    <!-- Nav Item Center - Mobile-->
    <v-layout
      v-if="isMobile"
      align-center 
      justify-center 
      row>
      <!-- Search Field - Friends -->
      <!-- <v-flex
        v-if="isMobile && searchActive"
        xs12
        md3>
        <v-scroll-x-reverse-transition 
          mode="out-in"
          hide-on-leave> -->
      <!-- Search Field -->
      <!-- <v-text-field 
            v-if="searchActive"
            label="Search"
            clearable
            autofocus
            single-line
            @blur="searchActivated">
          </v-text-field>
        </v-scroll-x-reverse-transition> 
      </v-flex> --> 


      <!-- Brand - Mobile -->
      <v-scroll-y-transition 
        mode="out-in"
        hide-on-leave>
        <v-flex 
          v-if="isMobile"
          xs12>
          <div 

            style="text-align: center;"
            class="wevent_icon_wrapper_brand">
            <img
              :src="getBrand"
              class="wevent_icon" 
              alt="WeVent">
          </div>
        </v-flex>
      </v-scroll-y-transition> 
    </v-layout>
   

    <v-spacer v-if="!isMobile" />


    <!-- Right Nav Item - Mobile -->
    <v-toolbar-items v-if="isMobile">
      <!-- <v-scroll-x-reverse-transition 
        leave-absolute
        hide-on-leave
        mode="out-in"> -->
      <v-btn 
        v-for="item in navItemRight"
        :key="item.title" 
        :to="item.path"
        icon>
        <v-badge 
          v-if="item.notifications === true && notifications_num > 0"
          size="50px"
          color="red"
          right>
          <template v-slot:badge>
            <span>
              {{ notifications_num }}
            </span>
          </template>
          <v-icon 
            class="wevent_icon_wrapper_icons" 
            color="blue-grey lighten-1">
            {{ item.icon }}
          </v-icon>
        </v-badge>
        <v-icon 
          v-else
          class="wevent_icon_wrapper_icons" 
          color="blue-grey lighten-1">
          {{ item.icon }}
        </v-icon>
      </v-btn>
      <!-- </v-scroll-x-reverse-transition> -->
    </v-toolbar-items>


    <!-- Right Nav Item - Desktop -->

    <!-- Search-Field -->
    <!-- <v-flex
      v-if="!isMobile"
      xs12
      md4>
      <v-scroll-x-reverse-transition 
        mode="out-in"
        hide-on-leave> -->
    <!-- <v-text-field 
          v-if="searchActive === true"
          v-model="search"
          label="Search"
          clearable
          prepend-inner-icon="fas fa-search"
          autofocus
          single-line
          @change="searchFriends"
          @blur="blur()"></v-text-field> -->
    <!-- <v-select
          v-if="searchActive === true"
          v-model="search"
          :items="items"

          label="Search"
          clearable
          prepend-inner-icon="fas fa-search"
          autofocus
          single-line
          @change="searchFriends"
          @blur="blur()">
        </v-select>
      </v-scroll-x-reverse-transition> 
    </v-flex> -->
    
    
  
    <v-toolbar-items v-if="!isMobile">
      <!-- Search-Button -->
      <!-- <v-scroll-x-transition 
        mode="out-in"
        hide-on-leave>
        <v-btn
          v-if="!searchActive"
          icon
          @click.native="clicked('Search')">
          <v-icon
            class="wevent_icon_wrapper_icons" 
            color="blue-grey lighten-1">
            fas fa-search
          </v-icon>
        </v-btn>
      </v-scroll-x-transition> -->
      <v-btn 
        v-for="item in navItems"
        :key="item.title" 
        :to="item.path"
        icon
        @click.prevent="toTop">
        <v-badge 
          v-if="item.notifications === true && notifications_num > 0"
          color="red"
          overlap>
          <template v-slot:badge>
            <span>
              {{ notifications_num }}
            </span>
          </template>
         
          <v-icon
            class="wevent_icon_wrapper_icons" 
            color="blue-grey lighten-1">
            {{ item.icon }}
          </v-icon>
        </v-badge>
        
        <v-icon 
          v-else
          class="wevent_icon_wrapper_icons" 
          color="blue-grey lighten-1">
          {{ item.icon }}
        </v-icon>
      </v-btn>
      
     

      <!-- Profile -->
      <v-btn 
        v-if="user"
        icon
        to="/profile">
        <v-avatar
          size="30px"
          color="blue-grey lighten-1">
          <img 
            :src="user.profileImg" 
            alt="avatar">
        </v-avatar>
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      
      
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      path: state => state.route.path,
      isMobile: state => state.isMobile,
      navItems: state => state.navigation.responsive.navItems,
      navItemLeft: state => state.navigation.responsive.navItemLeft,
      navItemRight: state => state.navigation.responsive.navItemRight,
      getBrand: state => require('@/assets/' + state.brand),
      searchActive: state => state.searchActive
    }),
    ...mapGetters({
      notifications_num: 'notifications_num'
    }),
  },
  methods: {
    ...mapMutations([
      'searchActivated',
      'setNavElementSearch',
      'clicktimelinedrawer',
      'click_profile_settingsdrawer',
    ]),

    activateSearch (val) {
      this.searchActivated()
      this.setNavElementSearch(this.searchActive)
    },

    getSelf() {
      return this
    },

    toTop() {
      this.$vuetify.goTo(0, {
        duration: 1000,
        offset: 0,
        easing: 'easeInOutQuint'
      })
    }
   
  
  

  }
}
</script>



<style scoped>

/* .v-toolbar {
   -webkit-box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
    box-shadow: 0px 2px 4px -1px rgba(216, 27, 96, 0.5), 0px 4px 5px 0px rgba(238, 255, 65, 0.3);
} */
/* #grad {
   background-image: linear-gradient(330deg, rgba(216,27,96,1), rgba(238,255,65,1)); 
     background-image: url('../../../assets/Background.svg'); 

    } */
.wevent_icon {
  margin-top: 12px;

  height: 28px !important;
  width: auto;
  -webkit-filter: invert(0.4) sepia(1) saturate(1) hue-rotate(175deg);
  filter: invert(0.4) sepia(1) saturate(1) hue-rotate(175deg);
/* -webkit-filter: invert(1) sepia(1) saturate(1) hue-rotate(175deg);
  filter: invert(1) sepia(1) saturate(1) hue-rotate(175deg); */

  /* filter: invert(0.6) sepia(0.8) saturate(5) hue-rotate(330deg); */
}
</style>
